import { render, staticRenderFns } from "./CategoryListing.vue?vue&type=template&id=55c3ad22&"
import script from "./CategoryListing.vue?vue&type=script&lang=js&"
export * from "./CategoryListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports